import {
  $greetingsTableSearchInputValue,
  $selectedGreetingIds,
  GreetingConditionTypeEnum,
  greetingsTableQuery,
  greetingsTableSearchChanged,
} from '@/entities/greetings'
import { greetingsStatus } from '@/entities/greetings'
import { STRINGS } from '@/shared/config'
import { useHashTabs } from '@/shared/lib/react-hooks'
import { BorderlessTabs, HeaderContent } from '@/shared/ui'
import { ContentWrapper } from '@/shared/ui'
import { PrimaryButton } from '@/shared/ui'
import { GreetingForm, greetingFormModalOpened } from '@/widgets/GreetingForm'
import {
  PlusOutlined,
  QuestionCircleOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import { Input, Layout, Popover, Space } from 'antd'
import { useUnit } from 'effector-react'

import {
  type SettingsGreetingsListPageTabsKeys,
  SettingsGreetingsListPageTabsKeysArray,
  SettingsGreetingsListPageTabsKeysEnum,
} from './lib/tabs'
import {
  $settingsGreetingsListPageTab,
  SettingsGreetingsListPageGate,
  settingsGreetingsListPageTabChanged,
} from './model/settings-greetings.model'
import { ActiveGreetingsTab } from './ui/GreetingsActiveTab'
import { InactiveGreetingsTab } from './ui/GreetingsInactiveTab'

export function GreetingsPage() {
  const { data } = useUnit(greetingsTableQuery)
  const search = useUnit($greetingsTableSearchInputValue)
  const changeSearch = useUnit(greetingsTableSearchChanged)
  const openFormModal = useUnit(greetingFormModalOpened)
  const changeStatus = useUnit(greetingsStatus)
  const selectedIds = useUnit($selectedGreetingIds)

  const { tab, handleTabChange } =
    useHashTabs<SettingsGreetingsListPageTabsKeys>(
      SettingsGreetingsListPageTabsKeysArray,
      $settingsGreetingsListPageTab,
      settingsGreetingsListPageTabChanged,
    )

  const selectedHasNoDate = selectedIds.some(
    (id) =>
      data &&
      data.items &&
      data.items.find(
        (item) =>
          item.id === id &&
          !item.sendOnStartDate &&
          !item.sendOnEndDate &&
          item.conditionType !== GreetingConditionTypeEnum.EveryDay,
      ),
  )

  return (
    <>
      <SettingsGreetingsListPageGate />
      <GreetingForm isModal />
      <Layout>
        <HeaderContent
          title="Приветственные экраны"
          description="Здесь можно создавать и редактировать приветственные экраны для пользователей"
          buttonSlot={
            <PrimaryButton
              onClick={() => {
                openFormModal()
              }}
              icon={<PlusOutlined />}
            >
              Создать
            </PrimaryButton>
          }
        />
        <ContentWrapper verticalPadding="small">
          <BorderlessTabs
            activeKey={tab}
            onChange={handleTabChange}
            destroyOnHidden
            tabBarExtraContent={
              <Space>
                {tab === 'inactive' && (
                  <Input
                    style={{ width: 500 }}
                    placeholder={STRINGS.placeholder_search_by_name_input}
                    allowClear
                    addonAfter={<SearchOutlined />}
                    value={(tab === 'inactive' ? search : '') || ''}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      const searchString = event.target.value
                      changeSearch(searchString)
                    }}
                  />
                )}
                <Popover
                  open={selectedHasNoDate ? undefined : false}
                  content={
                    <div
                      style={{
                        maxWidth: 320,
                        color: '#000000',
                        opacity: 0.45,
                      }}
                    >
                      <b>Выбран шаблон без даты</b>
                      <br />
                      Необходимо выставить дату показа перед активацией
                      приветственного экрана
                    </div>
                  }
                  placement="bottom"
                >
                  <PrimaryButton
                    onClick={() => {
                      changeStatus.start({
                        data: {
                          greetingIds: selectedIds,
                          isActive: tab === 'inactive',
                        },
                      })
                    }}
                    disabled={!selectedIds.length || selectedHasNoDate}
                  >
                    {tab === 'inactive' ? 'Активировать' : 'Сделать неактивным'}
                  </PrimaryButton>
                </Popover>
              </Space>
            }
            items={[
              {
                label: 'Неактивные',
                key: SettingsGreetingsListPageTabsKeysEnum.inactive,
                children: <InactiveGreetingsTab />,
              },
              {
                label: (
                  <Space size={4}>
                    <span>Приоритизация</span>
                    <Popover
                      content={
                        <div
                          style={{
                            maxWidth: 320,
                            color: '#000000',
                            opacity: 0.45,
                          }}
                        >
                          Для успешного показа приветственных <br /> экранов
                          необходимо расставить шаблоны
                          <br />
                          по приоритету — <b>чем выше, тем важнее</b>
                        </div>
                      }
                      placement="bottom"
                    >
                      <QuestionCircleOutlined
                        style={{ color: '#000000', opacity: 0.45 }}
                      />
                    </Popover>
                  </Space>
                ),
                key: SettingsGreetingsListPageTabsKeysEnum.active,
                children: <ActiveGreetingsTab />,
              },
            ]}
          />
        </ContentWrapper>
      </Layout>
    </>
  )
}
